import { flags } from "globals/flags";

export function checkFlag(name) {
  return Boolean(flags.get(name));
}

export function setFlag(name, val) {
  flags.set(name, Boolean(val));
}
